const priceRangeToString = (range, currency = '$') => {
  let rangeString = '';
  for (let i = 0; i < range; i += 1) {
    rangeString += currency;
  }
  return rangeString;
};

export default priceRangeToString;
